import React, { useState, useEffect } from "react";
import { Grid, Button, Container } from "@mui/material";
import LoaderContainer from "./LoaderContainer";
import { useTranslation } from "react-i18next";
import CustomAppBar from "./AppBar";
import { CustomTitle } from "./Custom/CustomTypography";
import api from "../globals/axios";
import FileUpload from "./Custom/FileUpload";
import { useLocation } from "react-router-dom";
import CustomTextField from "./Custom/CustomTextField";
import useFormValidation from "../components/Custom/FormValidation";
import { organizationValidationSchema } from "../components/Custom/ValidationSchema";
const validationSchema = organizationValidationSchema();
export default function CreateOrganization() {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const { errors, validate } = useFormValidation(data, validationSchema);
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const ordId = searchParams.get("ordId");
  useEffect(() => {
    if (ordId) {
      fetchFpoData(ordId);
      setIsEdit(true);
    } else {
      setLoading(false);
    }
  }, [isEdit]);

  const fetchFpoData = () => {
    api
      .get(`/fpo/fpo-details-get-set`)
      .then((response) => {
        if (response?.data) {
          const fpoData = response.data;
          setData(fpoData);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching farm data:", error);
      });
  };
  const handleChange = (name, value) => {
    setData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...data, [name]: value });
  };

  const onFileChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.files[0] });
    validate({ ...data, [event.target.name]: event.target.files[0] });
  };
  const submit = () => {
    validate(data);
    if (Object.keys(errors).length === 0) {
      const formData = new FormData();
      const fileFields = [
        "incorporation_certificate",
        "pan_card",
        "gst_certificate",
      ];

      for (const key in data) {
        if (data[key] === null) {
          continue;
        }
        if (Object.hasOwn(data, key)) {
          if (data[key] instanceof FileList) {
            formData.append(key, data[key][0]);
          } else {
            if (fileFields.includes(key) && typeof data[key] === "string")
              continue;
            formData.append(key, data[key]);
          }
        }
      }
      const apiRequest = isEdit
        ? api.patch(`/fpo/fpo_details/${ordId}/`, formData)
        : api.post("/fpo/fpo_details/", formData);

      apiRequest
        .then(() => {
          alert(isEdit ? "Updated Succesfully" : "Created Successfully .");
          window.location.href = "/fpo/profile";
        })
        .catch((error) => {
          alert("Error submitting. " + error);
        });
    } else {
      alert("Please fix the validation errors before submitting.");
    }
  };
  const fields = [
    {
      type: "text",
      label: t("Organization Name"),
      name: "name",
    },
    {
      type: "number",
      label: t("Year of Incorporation"),
      name: "year_of_incorporation",
    },
    {
      type: "file",
      label: t("Upload incorporation Certificate"),
      name: "incorporation_certificate",
      accept: ".pdf, .jpeg, .jpg, .heic, .png",
    },
    {
      type: "text",
      label: t("Pan Number"),
      name: "pan_number",
    },
    {
      type: "file",
      label: t("Upload Pan Card"),
      name: "pan_card",
      accept: ".pdf, .jpeg, .jpg, .heic, .png",
    },
    {
      type: "text",
      label: t("GST Number"),
      name: "gst_number",
    },
    {
      type: "file",
      label: t("Upload GST Certificate"),
      name: "gst_certificate",
      accept: ".pdf, .jpeg, .jpg, .heic, .png",
    },
    {
      type: "number",
      label: t("Total Farmers"),
      name: "farmer_count",
    },
    {
      type: "text",
      label: t("Address"),
      name: "address",
      rows: 4,
    },
  ];

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add Organization details")}</CustomTitle>
            <Grid container spacing={2}>
              {fields.map((field, index) => (
                <Grid item xs={12} key={index}>
                  {field.type === "file" ? (
                    <FileUpload
                      label={field.label}
                      onChange={onFileChange}
                      name={field.name}
                      accept={field.accept}
                      error={errors[field.name]}
                      helperText={errors[field.name]}
                      edit={isEdit}
                      disabled={isEdit}
                      fileData={data[field.name]}
                      documentId={data.id}
                    />
                  ) : (
                    <CustomTextField
                      label={field.label}
                      name={field.name}
                      value={data[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                      options={field.options}
                      rows={field.rows}
                      error={errors[field.name]}
                      helperText={errors[field.name]}
                    />
                  )}
                </Grid>
              ))}
              <Grid mx="auto" item xs={12}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{ color: "white" }}
                  onClick={submit}
                >
                  {t("Submit")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
